import PropTypes from "prop-types";
import styles from "../../../StyleCount.css";

const StyleCount = ({ itemCount }, { formatTranslation, formatNumber }) => {
  const getItemCountDisplay = count => {
    if (count >= 1000) return "1000+";
    if (count >= 500) return "500+";
    if (count >= 100) return "100+";
    if (count < 100) return formatNumber(count);

    return formatNumber(count);
  };

  const itemCountToDisplay = getItemCountDisplay(itemCount);

  return (
    <p className={styles.styleCount}>
      {formatTranslation("plp_web_style_count_noun", {
        smart_count: itemCount,
        formattedCount: itemCountToDisplay
      })}
    </p>
  );
};

StyleCount.propTypes = {
  itemCount: PropTypes.number.isRequired
};

StyleCount.contextTypes = {
  formatTranslation: PropTypes.func.isRequired,
  formatNumber: PropTypes.func.isRequired
};

export default StyleCount;
